export default __webpack_public_path__ + "static/media/logged_home_root_background.d4682995.jpg";